import type {
  ActionPerformed,
  // PushNotificationSchema,
  Token,
} from '@capacitor/push-notifications'
import { PushNotifications } from '@capacitor/push-notifications'
import {Capacitor} from "@capacitor/core"
import axios from "axios"
import router from "@/router"
import { Device } from '@capacitor/device'

export function requestPermissions() {
  if (!Capacitor.isNativePlatform()) return

  PushNotifications.requestPermissions().then(result => {
    if (result.receive === 'granted') {
      // Register with Apple / Google to receive push via APNS/FCM
      PushNotifications.register()
    } else {
      // Show some error
    }
  })
}

if (Capacitor.isNativePlatform()) {
  PushNotifications.addListener('registration',
    async (token: Token) => {
      // alert('Push registration success, token: ' + token.value)
      const deviceId = await Device.getId()

      axios.post("/auth/push-token", { push_token: token.value, device_id: deviceId.identifier }).catch((e) => e)
    }
  )

  // PushNotifications.addListener('registrationError',
  //   (error: any) => {
  //     alert('Error on registration: ' + JSON.stringify(error))
  //   }
  // )
  //
  // PushNotifications.addListener('pushNotificationReceived',
  //   (notification: PushNotificationSchema) => {
  //     alert('Push received: ' + JSON.stringify(notification))
  //   }
  // )

  // Method called when tapping on a notification
  PushNotifications.addListener('pushNotificationActionPerformed',
    (payload: ActionPerformed) => {
      // alert('Push action performed: ' + JSON.stringify())
      const url = payload.notification.data?.url
      if (url) {
        const path = new URL(url).pathname
        router.push(path).catch((e) => e)
      }
    }
  )
}
